<template>
  <Stack id="layout" tag="main" direction="col" gap="none" class="min-h-screen">
    <div
      v-if="overlay"
      class="bg-[#000] fixed top-none h-full w-full z-30 opacity-50 cursor-pointer"
      @click="onOverlayClick"
    />
    <slot />
  </Stack>
  <NotificationToast />
</template>

<script lang="ts" setup>
const { connect } = useSession();
const { overlay, onOverlayClick } = useUIState();
await connect();
</script>
